import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getNotification, seenNotification } from 'api/notifications';

export const getNotificationsRequests = createAsyncThunk(
  'notifications/getNotificationsRequests',
  async () => await getNotification(),
);

export const seenNotificationsRequests = createAsyncThunk(
  'notifications/seenNotifications',
  async ({ type, entityId }: { type: PUSH_TYPE; entityId?: string }) => {
    await seenNotification(type, entityId);

    return { type, entityId };
  },
);

export enum PUSH_TYPE {
  POST = 'new-post',
  EVENT = 'new-event',
  CONTACT_REQUEST = 'contact-request',
  MESSAGE = 'message',
  COMMENT = 'comment',
  POSTLIKE = 'postLike',
  KREISE = 'kreise',
}

const keyType = {
  [PUSH_TYPE.POST]: 'post',
  [PUSH_TYPE.EVENT]: 'event',
  [PUSH_TYPE.CONTACT_REQUEST]: 'request',
  [PUSH_TYPE.MESSAGE]: 'message',
  [PUSH_TYPE.COMMENT]: 'comment',
};

export interface INotificationData {
  createdAt: string;
  data: any | null; // dont know what will be returned
  entity: string;
  type: PUSH_TYPE;
  updatedAt: string;
}

const initialState = {
  post: [] as INotificationData[],
  event: [] as INotificationData[],
  request: [] as INotificationData[],
  message: [] as INotificationData[],
  comment: [] as INotificationData[],
};

export const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getNotificationsRequests.fulfilled, (state, action) => {
        state.post = action.payload?.filter((pushState) => pushState.type === PUSH_TYPE.POST);
        state.event = action.payload?.filter((pushState) => pushState.type === PUSH_TYPE.EVENT);
        state.message = action.payload?.filter((pushState) => pushState.type === PUSH_TYPE.MESSAGE);
        state.request = action.payload?.filter((pushState) => pushState.type === PUSH_TYPE.CONTACT_REQUEST);
      })
      .addCase(seenNotificationsRequests.fulfilled, (state, { payload }) => {
        const { type, entityId } = payload;
        const notificationKey = keyType[type];

        if (entityId) {
          state[notificationKey] = state[notificationKey].filter((notification) => notification.entity !== entityId);
        }
        state[notificationKey] = [];
      });
  },
});

export const notifications = notificationsSlice.reducer;
